<template>
  <div id="confirm-point-step">

    <step-template>
      <div slot="back" @click="back">&larr;</div>
      <div slot="default">
        <div class="mb-6">Is your point in the right place?</div>
        <div class="flex">
          <csf-button type="primary" @click="next" class="mr-4">Yes</csf-button>
          <csf-button @click="back">No</csf-button>
        </div>
      </div>
    </step-template>

  </div>
</template>

<script>
import CsfButton from "../components/csf-button.vue";
import StepTemplate from "./step-template.vue";

export default {
  // global
  name: "confirm-point-step",
  components: { CsfButton, StepTemplate },
  methods: {
    back() {
      this.$store.commit("clearPinLatLng");
      this.$store.commit("transition", { action: "BACK" });
    },
    next() {
      this.$store.commit("transition", { action: "SUBMIT" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/sass/variables";
</style>



// WEBPACK FOOTER //
// ConfirmPointStep.vue?8f7550fa